import * as React from 'react';
import AppointmentFeedback from './appointment_feedback_component';

interface Feedback {
  template: { label: string; response: string }[];
  appointment: { id: string };
}

interface appointment_pdf_bodyProps {
  appointments: string[][];
  notListing: boolean;
  reindex: 1 | 0;
  showContactInfo: boolean;
  showFeedback: boolean;
  findFeedbackByAppointmentIndex: (appointmentIndex: number) => Feedback;
  isVirtualTour: boolean;
}

const appointment_pdf_body: React.FC<appointment_pdf_bodyProps> = ({
  appointments,
  notListing,
  reindex,
  showContactInfo,
  showFeedback,
  findFeedbackByAppointmentIndex,
  isVirtualTour,
}) => (
    <tbody className="print-body">
      <tr>
        <td>
          <div className="row">
            <div className="col-xs-12">
              <table className="table table-borderless">
                {/**
                 * A table inside a table! Outer table is just for
                 * print pagination purposes. The inner table is the
                 * one that actually formats the rows into a table.
                 */}
                <thead>
                  <tr>
                    <th />
                    <th style={{ width: showContactInfo ? '20%' : '40%' }}>
                      Date / Time
                    </th>
                    {showContactInfo && (
                      <th
                        style={{
                          width: '30%',
                        }}
                      >
                        Agent
                      </th>
                    )}
                    {showContactInfo && (
                      <th style={{ width: '35%' }}>Contact</th>
                    )}
                    <th
                      style={{
                        width: showContactInfo ? '10%' : '55%',
                      }}
                    >
                      Status
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {appointments.map((values, index) => (
                    <React.Fragment key={index}>
                      <tr>
                        <td />
                        <td colSpan={showContactInfo ? 4 : 3}>
                          <div className="row">
                            {/* Show divider after every appt but the last */}
                            <hr className="m-n" />
                          </div>
                        </td>
                      </tr>
                      {notListing && (
                        <tr>
                          <td>{index + 1}.</td>
                          <td colSpan={3}>{values[2]}</td>
                        </tr>
                      )}
                      <tr>
                        {!notListing ? <td>{index + 1}.</td> : <td />}
                        <td>
                          {values[0]}
                          <br />
                          {values[1]}
                        </td>
                        {showContactInfo && (
                          <td>
                            {values[2 + reindex]}
                            <br />
                            {values[3 + reindex]}
                            <br />
                            office: {values[6 + reindex]}
                          </td>
                        )}
                        {showContactInfo && (
                          <td style={{ wordBreak: 'break-all' }}>
                            {values[4 + reindex]}
                            <br />
                            mobile: {values[5 + reindex]}
                          </td>
                        )}
                        <td style={{ textTransform: 'capitalize' }}>
                          {values[7 + reindex]}
                        </td>
                      </tr>

                      {/* Feedback will show on the next tr if checked */}
                      {showFeedback && !isVirtualTour && (
                        <tr>
                          <td />
                          {/* Span of feedback cell depends on whether there's a Contact column or not */}
                          <td colSpan={showContactInfo ? 4 : 3}>
                            <div className="row" style={{ marginLeft: 0 }}>
                              <label>Feedback</label>
                            </div>

                            {/* Render feedback if it exists, or a message otherwise */}
                            {findFeedbackByAppointmentIndex(index) ? (
                              <AppointmentFeedback
                                feedback={findFeedbackByAppointmentIndex(index)}
                              />
                            ) : (
                              <span>
                                There is no available feedback for this showing.
                              </span>
                            )}
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </td>
      </tr>
    </tbody>
  );

export default appointment_pdf_body;
